export default function SciFiBackdrop() {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 pointer-events-none z-0 overflow-hidden"
      data-testid="scifi-backdrop"
    >
      {/* Grid */}
      <div className="absolute inset-0 grid-overlay opacity-70" />

      {/* Soft radial glow top right */}
      <div
        className="absolute -top-40 -right-40 w-[60vw] h-[60vw] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgb(var(--primary) / 0.22) 0%, rgb(var(--primary) / 0) 60%)",
        }}
      />

      {/* Soft radial glow bottom left */}
      <div
        className="absolute -bottom-60 -left-40 w-[70vw] h-[70vw] rounded-full blur-3xl"
        style={{
          background:
            "radial-gradient(circle, rgb(var(--accent) / 0.10) 0%, rgb(var(--accent) / 0) 60%)",
        }}
      />

      {/* Scan lines overlay */}
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "repeating-linear-gradient(to bottom, rgb(var(--text) / 0.02) 0 1px, transparent 1px 4px)",
        }}
      />

      {/* Vignette — theme aware */}
      <div className="absolute inset-0 vignette" />
    </div>
  );
}
